import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import React, { Fragment } from 'react';
import clsx from 'clsx';
import routesConfig from '../../pages/routeConfig';
import { useIntl } from 'react-intl';
import { useSidebarContext } from './AppContextProvider/SidebarContextProvider';
import useHasPermission, {
  PermissionChecker,
} from 'src/shared/functions/access-control';

const MenuItemChildren = ({ item }: { item: any }) => {
  const { icon, messageId, path } = item;
  const { messages } = useIntl();

  if (path && path.includes('/'))
    return (
      <Link to={path}>
        {icon &&
          (React.isValidElement(icon) ? (
            <span className='ant-menu-item-icon'>{icon}</span>
          ) : (
            <span className='ant-menu-item-icon' />
          ))}
        <span data-testid={messageId.toLowerCase() + '-nav'}>
          {messages[messageId]?.toString()}
        </span>
      </Link>
    );
  else {
    return (
      <Fragment>
        {icon &&
          (React.isValidElement(icon) ? (
            <span className='ant-menu-item-icon'>{icon}</span>
          ) : (
            <span className='ant-menu-item-icon' />
          ))}
        <span data-testid={messageId.toLowerCase() + '-nav'}>
          {messages[messageId]?.toString()}
        </span>
      </Fragment>
    );
  }
};

const renderMenu = (
  item: any,
  sidebarColorSet: any,
  isSidebarBgImage: any,
  index: any,
  hasPermission: PermissionChecker,
  viewInList: boolean = true,
) => {
  return viewInList ? (
    item.type === 'group' ? (
      <Menu.SubMenu
        key={item.path ? item.path : item.id}
        title={<MenuItemChildren item={item} />}
        popupClassName={clsx('app-sidebar-popup', {
          'app-sidebar-popup-nested': index > 0,
        })}
      >
        {item.children.map((item: any) =>
          renderMenu(
            item,
            sidebarColorSet,
            isSidebarBgImage,
            index + 1,
            hasPermission,
            hasPermission(item?.permissionKey),
          ),
        )}
      </Menu.SubMenu>
    ) : (
      <Menu.Item key={item.id}>
        {item.children ? item.children : <MenuItemChildren item={item} />}
      </Menu.Item>
    )
  ) : null;
};

export const useRouteMenus = () => {
  const { sidebarColorSet }: any = useSidebarContext();
  const { isSidebarBgImage }: any = useSidebarContext();
  const hasPermission = useHasPermission();
  return routesConfig.map((route: any) =>
    renderMenu(
      route,
      sidebarColorSet,
      isSidebarBgImage,
      0,
      hasPermission,
      hasPermission(route?.permissionKey),
    ),
  );
};
